import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  BadgeComponent,
  ButtonComponent,
  IconButtonComponent,
  IconColorDirective,
  IconComponent,
} from '@core/user-interface-legacy';

import type { ArrowPosition, ArrowType, WalkthroughComponentProperties } from '../../types';

@Component({
  selector: 'rt-walkthrough-tooltip',
  imports: [
    ButtonComponent,
    NgClass,
    IconButtonComponent,
    IconColorDirective,
    IconComponent,
    BadgeComponent,
    TranslatePipe,
  ],
  templateUrl: './walkthrough-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './walkthrough-tooltip.component.less',
})
export class WalkthroughTooltipComponent implements WalkthroughComponentProperties {
  private readonly i18n = inject(I18nService);

  public readonly arrowConfig = input<[ArrowPosition, ArrowType]>(['middle', 'left']);

  public readonly currentStep = input<number>(undefined!);
  public readonly stepsTotal = input<number>(undefined!);
  public readonly showStepCounter = input<boolean>(true);
  public readonly hasNewBadge = input<boolean>(false);
  public readonly hasTipBadge = input<boolean>(false);

  public readonly heading = input<string>(undefined!);
  public readonly description = input<string>(undefined!);

  public readonly ofText = input<string>(this.i18n.translate('app.common.of'));
  public readonly ctaHandler = input<() => void>();
  @Input() public ctaText: string;
  @Input() public ctaIcon?: IconName = undefined;

  @Output()
  public cancel = new EventEmitter<void>();
  public finish = new EventEmitter<void>();
  public next = new EventEmitter<void>();

  public handleCtaClicked(): void {
    const ctaHandler = this.ctaHandler();
    if (!!ctaHandler) {
      ctaHandler();
    }
    this.next.emit();
  }

  public closeTooltip() {
    this.cancel.emit();
  }
}
